import React, { useCallback, useEffect, useState } from 'react';
import { App, Button, Drawer, Form, Input, InputNumber, Space, Table, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import useComponentTypesApi from 'pages/liftlogic/v2/Components/useComponentTypesApi';

// Gestiona el catálogo de tipos de componente GLOBAL (liftlogic super-tenant).
function ComponentTypesContent() {
  const api = useComponentTypesApi();
  const { message } = App.useApp();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.list();
      setTypes(data.types || []);
    } catch (e) {
      message.error('No se pudo cargar los tipos de componente');
    } finally {
      setLoading(false);
    }
  }, [api, message]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const onAdd = () => {
    setEditing(null);
    form.resetFields();
    setOpen(true);
  };
  const onEdit = (row) => {
    setEditing(row);
    form.setFieldsValue({ key: row.key, label: row.label, sort_order: row.sort_order });
    setOpen(true);
  };
  const onSubmit = async () => {
    const values = await form.validateFields();
    const payload = {
      key: values.key,
      label: values.label,
      sort_order: values.sort_order ?? 0,
    };
    try {
      if (editing) await api.update(editing.id, payload);
      else await api.create(payload);
      message.success('Guardado');
      setOpen(false);
      refresh();
    } catch (e) {
      message.error(e?.response?.data?.message || 'Error al guardar');
    }
  };
  const onDelete = async (row) => {
    try {
      await api.remove(row.id);
      message.success('Eliminado');
      refresh();
    } catch (e) {
      message.error('No se pudo eliminar');
    }
  };

  const columns = [
    { title: 'Key', dataIndex: 'key' },
    { title: 'Etiqueta', dataIndex: 'label' },
    { title: 'Orden', dataIndex: 'sort_order' },
    {
      title: 'Acciones',
      key: 'acc',
      render: (_, row) => (
        <Space>
          <Button size="small" icon={<EditOutlined />} onClick={() => onEdit(row)} />
          <Popconfirm title="¿Eliminar tipo?" onConfirm={() => onDelete(row)}>
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Space style={{ marginBottom: 12 }}>
        <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
          Nuevo tipo
        </Button>
      </Space>
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={types}
        pagination={false}
      />
      <Drawer
        title={editing ? 'Editar tipo' : 'Nuevo tipo'}
        open={open}
        onClose={() => setOpen(false)}
        footer={
          <Space style={{ float: 'right' }}>
            <Button onClick={() => setOpen(false)}>Cancelar</Button>
            <Button type="primary" onClick={onSubmit}>
              Guardar
            </Button>
          </Space>
        }
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="key"
            label="Key (snake_case)"
            rules={[
              { required: true },
              { pattern: /^[a-z0-9_]+$/, message: 'Solo minúsculas, números y _' },
            ]}
          >
            <Input disabled={!!editing} placeholder="ascensor_hidraulico" />
          </Form.Item>
          <Form.Item name="label" label="Etiqueta" rules={[{ required: true }]}>
            <Input placeholder="Ascensor hidráulico" />
          </Form.Item>
          <Form.Item name="sort_order" label="Orden">
            <InputNumber min={0} style={{ width: '100%' }} placeholder="0" />
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}

export default ComponentTypesContent;
